import { ReactNode } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { styled } from '@mui/material/styles';
import 'react-alice-carousel/lib/alice-carousel.css';

export type CarouselProps = {
  childs: ReactNode[];
};

const SliderStyled = styled(AliceCarousel)(({ theme }) => ({}));

const SliderContainerStyled = styled('div')(({ theme }) => ({}));

export const Carousel = ({ childs }: CarouselProps) => {
  const settings = {
    disableButtonsControls: true,
  };
  return (
    <SliderContainerStyled>
      <SliderStyled {...settings} items={childs}></SliderStyled>
    </SliderContainerStyled>
  );
};
